<template>
  <div class="proforientacia-page">
    <app-header-proforientacia-page
      @open-modal="openModal('Форма в шапке')"
    />

    <proforientacia-banner
      @open-modal="openModal('Форма начать тест')"
    />

    <section class="proforientacia-page__cell">
      <proforientacia-course />

      <proforientacia-experts />

      <proforientacia-form />
    </section>

    <common-modals />

    <proforientacia-form-modal
      v-if="showModal"
      :form-title="titleToSend"
      @close-modal="closeModal"
    />

    <app-footer-proforientacia-page />
  </div>
</template>

<script>
import HeadMixin from '@/mixins/HeadMixin';

import AppHeaderProforientaciaPage from '~/components/v2/proforientacia/AppHeaderProforientaciaPage.vue';
import AppFooterProforientaciaPage from '~/components/v2/proforientacia/AppFooterProforientaciaPage.vue';
import ProforientaciaBanner from '~/components/v2/proforientacia/ProforientaciaBanner.vue';
import ProforientaciaCourse from '~/components/v2/proforientacia/ProforientaciaCourse.vue';
import ProforientaciaExperts from '~/components/v2/proforientacia/ProforientaciaExperts.vue';
import ProforientaciaForm from '~/components/v2/proforientacia/ProforientaciaForm.vue';
import CommonModals from '~/components/v2/modals/CommonModals.vue';
import ProforientaciaFormModal from '@/components/v2/proforientacia/ProforientaciaFormModal.vue';

export default {
  name: 'ProforientaciaPage',
  components: {
    ProforientaciaForm,
    AppHeaderProforientaciaPage,
    AppFooterProforientaciaPage,
    ProforientaciaBanner,
    ProforientaciaCourse,
    ProforientaciaExperts,
    CommonModals,
    ProforientaciaFormModal,
  },
  mixins: [HeadMixin],
  layout: 'emptyLayout',
  data: () => ({
    titleToSend: '',
    showModal: false,

    // для head
    title: 'Профориентация для школьников 5–11 классов: выбор будущей профессии и развитие навыков',
    // eslint-disable-next-line max-len,vue/max-len
    description: 'Профориентация для школьников 5–11 классов: онлайн-тесты, консультации и рекомендации по выбору будущей профессии. Развиваем навыки и таланты, помогаем определиться с направлением обучения и выбрать подходящий вуз или колледж.',
    headScripts: [{
      // eslint-disable-next-line max-len,vue/max-len
      src: 'https://js.onef.pro/static/reg1f_v1.js?1f_pixel_id=24aed672-c5f3-4e78-ba7e-eed74b860cd1&event_type=visit&product=new_online_school_soft_skills',
      defer: true,
      type: 'text/javascript',
    }],
    canonical: true,
  }),

  methods: {
    openModal(title) {
      this.titleToSend = title;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped lang="scss">
main * {
  font-family: 'TildaSans', sans-serif;
}

::v-deep button {
  font-family: 'TildaSans', sans-serif;
}

::v-deep input {
  font-family: 'TildaSans', sans-serif !important;
}

// артефакты от старых страниц
::v-deep section {
  margin-bottom: 0;

  h2,
  h3 {
    margin: 0;
  }
}

.proforientacia-page {
  ::v-deep .page-bottom-banner ~ .header {
    .header__inner {
      @include media-down(tablet) {
        top: 60px;

        .m-menu--active {
          top: 106px;
        }
      }
    }
  }

  @include media-down(tablet) {
    ::v-deep .page-bottom-banner ~ .school-page {
      position: relative;
      top: 60px;
    }
  }

  &__cell {
    display: flex;
    flex-direction: column;
    gap: 180px;

    padding-top: 180px;
    padding-bottom: 180px;

    background-image: url("/v2/soft-skills/course/course-bg.webp");
    background-size: cover;

    @include media-down(laptop) {
      gap: 140px;
      padding-top: 100px;
      padding-bottom: 100px;

      background-size: 1500px, 100% 100%;
    }

    @include media-down(tablet) {
      gap: 100px;

      background-image: url("/v2/common/grid.svg"), url("/v2/soft-skills/course/course-bg-mob.webp");
      background-size: 960px, 100% 100%;
    }
  }
}
</style>
